import { Store, OpeningHours } from '../hooks/types'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { ProcessedStoreServiceSite } from '../services/cinch-servicing/types'

const isRealTimeBookingEnabled =
  readFromEnv(Env.EnableServiceBooking) === 'true'

export const mapSitesToStores = (
  stores: ProcessedStoreServiceSite[],
): Store[] =>
  stores.map((site) => {
    const addressAttr = site.attributes.find(
      (attr) => attr.attributeId === 'address',
    )
    const coordsAttr = site.attributes.find(
      (attr) => attr.attributeId === 'coordinates',
    )

    const workshopPlusAttr = site.attributes.some(
      (attr) => attr.attributeId === 'workshop-plus',
    )

    const dealerIdAttr = site.attributes.find(
      (attr) => attr.attributeId === 'workshop-plus-dealer-id',
    )

    const openingHoursAttr = site.attributes.find(
      (attr) => attr.attributeId === 'opening_hours',
    )

    const dealerCodeAttr = site.attributes.find(
      (attr) => attr.attributeId === 'edynamix-dealer-code',
    )

    const nonCagAttr = site.attributes.find(
      (attr) => attr.attributeId === 'non-cag-site',
    )

    const addressValue = addressAttr?.attributeValue as {
      addressLine1: string
      city: string
      county: string
      postcode: string
    }
    const coordsValue = coordsAttr?.attributeValue as {
      latitude: number
      longitude: number
    }

    let openingHours: OpeningHours | undefined
    if (openingHoursAttr?.attributeValue) {
      try {
        const hoursArray = openingHoursAttr.attributeValue as Array<{
          department: string
          monday?: { start: string; end: string }
          tuesday?: { start: string; end: string }
          wednesday?: { start: string; end: string }
          thursday?: { start: string; end: string }
          friday?: { start: string; end: string }
          saturday?: { start: string; end: string }
          sunday?: { start: string; end: string }
        }>

        const serviceHours = hoursArray.find(
          (hours) => hours.department?.toLowerCase() === 'service',
        )

        if (serviceHours) {
          openingHours = {
            monday: serviceHours.monday || { start: 'Closed', end: 'Closed' },
            tuesday: serviceHours.tuesday || { start: 'Closed', end: 'Closed' },
            wednesday: serviceHours.wednesday || {
              start: 'Closed',
              end: 'Closed',
            },
            thursday: serviceHours.thursday || {
              start: 'Closed',
              end: 'Closed',
            },
            friday: serviceHours.friday || { start: 'Closed', end: 'Closed' },
            saturday: serviceHours.saturday || {
              start: 'Closed',
              end: 'Closed',
            },
            sunday: serviceHours.sunday || { start: 'Closed', end: 'Closed' },
          }
        }
      } catch (error) {
        console.error(
          'Error parsing opening hours for',
          site.siteId,
          ':',
          error,
        )
      }
    }

    return {
      id: site.siteId,
      name: site.attributes.find((attr) => attr.attributeId === 'display_name')
        ?.attributeValue as string,
      displayName: site.displayName,
      addressLine1: addressValue?.addressLine1 || '',
      town: addressValue.city,
      county: addressValue.county,
      postcode: addressValue.postcode,
      coordinates: coordsValue,
      canBookAppointment: isRealTimeBookingEnabled && workshopPlusAttr,
      dealerId:
        (isRealTimeBookingEnabled &&
          (dealerIdAttr?.attributeValue as string)) ||
        '',
      openingHours,
      dealerCode: (dealerCodeAttr?.attributeValue as string) || '',
      isNonCag: !!nonCagAttr,
    }
  })
